import React, { useState } from 'react'

import { notification } from 'antd'
import { Button } from 'primereact/button'
import { DataTable } from 'primereact/datatable'

import { getMessage } from '../../../util/IntlMessages'
import { api, request } from '../../../util/handlerRequestUtil'
import { columnsCustomerAvailableList } from '../utils'
import { getCurrentReferencePeriodId } from '../../../util/getCurrentReferencePeriod'

const CustomerAvailableList = ({ state, setState, history, listCustomers, loadWalletByDistrict }) => {
  const [selectedRows, setSelectedRows] = useState([])

  async function addSelectedCustomersInWallet() {
    const { memberData, modalVisible } = state

    if (selectedRows.length === 0) {
      notification.warning({
        description: getMessage('addCustomersError'),
        message: getMessage('sweetAlerts.warning')
      })
      return
    }

    const referencePeriods = await api.listSafraDropdown({ active: true })
    const currentReferencePeriod = getCurrentReferencePeriodId(referencePeriods)

    const currentCustomerCount = parseInt(memberData.customers_count)
    const wallet = await api.listEibConfigCalendarios()
    const maxCustomerCount =
      wallet.find(
        ({ organizationId, referencePeriodId }) =>
          organizationId === memberData.organization_id && referencePeriodId === currentReferencePeriod
      ).clientQuantity || 0
    const selectedCustomerCount = selectedRows.length

    if (currentCustomerCount + selectedCustomerCount > maxCustomerCount) {
      notification.warning({
        description: 'O limite de clientes na carteira foi atingido.',
        message: 'Limite Excedido'
      })
      return
    }

    setState({
      ...state,
      addCustomerTableLoading: true
    })

    try {
      const payload = {
        customerLinkList: selectedRows,
        carteiraId: memberData.id
      }

      await request(api.addCustomersWalletsByList(payload))
      await new Promise((r) => setTimeout(r, 200))

      const formattedResponse = await listCustomers()

      const updatedMemberData = {
        ...memberData,
        customers_count: currentCustomerCount + selectedCustomerCount
      }

      const updatedState = {
        ...state,
        addCustomerTableLoading: false,
        customerAvailableList: formattedResponse,
        addCustomerSelectedRows: [],
        memberData: updatedMemberData,
        modalVisible: !modalVisible
      }
      setSelectedRows([])
      const historyState = {
        ...history.location.state,
        customers_count: updatedMemberData.customers_count
      }

      history.replace({ pathname: history.location.pathname, state: historyState })

      const formattedCustomerList = await loadWalletByDistrict(updatedState)
      setState({ ...updatedState, customerList: formattedCustomerList })

      notification.success({
        description: getMessage('addCustomersSuccess'),
        message: getMessage('sweetAlerts.success')
      })
    } catch (error) {
      console.tron.log(error)
      notification.error({
        description: getMessage('addCustomersError'),
        message: getMessage('sweetAlerts.error')
      })
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <DataTable
        value={state.customerAvailableList}
        selection={selectedRows}
        onSelectionChange={(e) => setSelectedRows(e.value)}
        responsiveLayout="scroll"
        selectionPageOnly
        first={0}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        scrollable
        scrollHeight="50vh"
        filterDisplay="row"
        responsive
        emptyMessage={getMessage('emptyCustomer')}
      >
        {columnsCustomerAvailableList}
      </DataTable>
      <Button
        label={getMessage('addSelectedCustomers')}
        icon="pi pi-check"
        onClick={addSelectedCustomersInWallet}
        style={{ width: '40%', marginLeft: '60%', marginTop: 15 }}
      />
    </div>
  )
}

export default CustomerAvailableList
